import qs from 'query-string';
import type { ParsedUrlQuery } from 'querystring';
import site from 'pro/config/site';
import { getSearch } from 'ava-util/dist/request';

/**
 * 获取影响页面渲染的url
 * @param queryKeys
 */
function getCanonicalUrl(pathname: string, query: Record<string, any>, queryKeys: string[] = []): string {
    const newQuerys: ParsedUrlQuery = {};
    let isQueryEmpty = true;

    Object.entries(query as Record<string, string>).map(([key, value]) => {
        if (queryKeys.includes(key)) {
            newQuerys[key] = value;
            isQueryEmpty = false;
        }
    });

    if (!isQueryEmpty) {
        return `${pathname}?${qs.stringify(newQuerys, { arrayFormat: 'bracket' })}`
    }
    return pathname;
}

export function getClientCanonicalUrl(): string {
    if (typeof window !== 'undefined') {
        const canonicalLink = document.querySelector('link[rel="canonical"]');
        if (canonicalLink) {
            const href = canonicalLink.getAttribute('href') || '';
            const search = getSearch(href)
            // 删除 orgion 和 query
            let pathname = href.replace(`https://${site.affiliation}`, '').replace(/\?.*$/, '');
            // 删除 locale
            pathname = pathname.replace(/^\/[a-zA-Z]{2}(-[a-zA-Z]{2}){0,1}$/, '/').replace(/^\/[a-zA-Z]{2}(-[a-zA-Z]{2}){0,1}\//, '/');
            return pathname + search;
        }
    }
    return '';
}

export default getCanonicalUrl;